export default __webpack_public_path__ + "static/media/save.b7d9c8a1.svg";